export const country2Money = {
  '尼日利亚': {
    register: 45, // 邀请好友注册
    info: 45, // 注册并补充个人信息
    apply: 45, // 申请借款
    pay: 650, // 开始还款
    payOff: 650, // 还款完成
    friend: 650, // 邀请的好友再邀请好友
    unit: '₦', // 单位
  },
  '肯尼亚': {
    register: 10,
    info: 10,
    apply: 10,
    pay: 150,
    payOff: 150,
    friend: 150,
    unit: 'KSh',
  },
}